module.exports = __webpack_public_path__ + "img/icon_phone.06450e4a.svg";